import { styled } from 'styled-components';

import { MODAL_CONTENT_PADDING } from '@/styles.ts';
import { responsive } from '@/utils';

/** Keeps the tabs in view while the selected tab scrolls below them. */
export const StyledPresetTabs = styled.div`
  flex: 0 0 auto;
  padding: ${MODAL_CONTENT_PADDING} ${MODAL_CONTENT_PADDING} 0;
`;

export const StyledPresetTabPanel = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  gap: ${responsive.spacing.xlarge};
  min-height: 0;
  overflow-y: auto;
  padding: ${responsive.spacing.xlarge} ${MODAL_CONTENT_PADDING} ${MODAL_CONTENT_PADDING};
`;
